import { render, staticRenderFns } from "./Boosting.vue?vue&type=template&id=436c3c42&scoped=true&"
import script from "./Boosting.vue?vue&type=script&lang=js&"
export * from "./Boosting.vue?vue&type=script&lang=js&"
import style0 from "./Boosting.vue?vue&type=style&index=0&id=436c3c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c3c42",
  null
  
)

export default component.exports